import React from 'react';
import PropTypes from 'prop-types';

import { useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import { useNotification } from '@sopranodesign/pulse-components';

import { createClient } from '../../../api/index';
import ClientDetails from './ClientDetails';

const CreateClient = ({ onClientCreated, trustedSenders}) => {
  const { showSuccess } = useNotification();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createClient,
    onSuccess: ({ data: { data } }) => {
      queryClient.invalidateQueries('clients');
      queryClient.invalidateQueries('owner/clients');
      onClientCreated(data);
      showSuccess(`Successfully created client "${data.name}"`);
    }
  });

  const handleSubmit = form => {
    mutation.mutate(form);
  };

  return <ClientDetails onSubmit={handleSubmit} loading={mutation.isPending} trustedSenders={trustedSenders}/>;
};

CreateClient.propTypes = {
  onClientCreated: PropTypes.func.isRequired,
  trustedSenders: PropTypes.array.isRequired
};

export default CreateClient;
